const actions = {
  SET_STATE: 'partner/SET_STATE',
  SHOW_PARTNER: 'partner/SHOW_PARTNER',
  CONNECT_PARTNER: 'partner/CONNECT_PARTNER',
  DISCONNECT_PARTNER: 'partner/DISCONNECT_PARTNER',

  SET_GOOGLE_ACCOUNT_STATE: 'partner/SET_GOOGLE_ACCOUNT_STATE',
  SHOW_PARTNER_GOOGLE_BUSINESS_ACCOUNTS: 'partner/SHOW_PARTNER_GOOGLE_BUSINESS_ACCOUNTS',
}

export default actions
